<section id="myskills">
    <div class="content">
        <div class="link-mb">
            <a href="#contact">{{text.cta}}</a>
        </div>
        <app-skill class="icons"></app-skill>
        <div class="myskills">
            <div class="header">
                <h2>{{text.header}}</h2>
                <div class="blueline"></div>
            </div>
            <span>{{text.description}}</span>
            <a href="#contact">{{text.cta}}</a>
        </div>
    </div>
</section>